import qs from 'qs'
import axios from 'axios'
import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import LocalStorageService from './LocalStorageService'
import router from '../router/routes'
import 'vue-toast-notification/dist/theme-sugar.css'

Vue.use(VueToast)

const localStorageService = LocalStorageService.getService()
// PUBLIC_URLS = [
//   // Commercial
//   `${process.env.VUE_APP_COMMERCIAL_API}invoices/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}quotations/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}credits/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}purchase-orders/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}invoices/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}quotations/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}credits/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}purchase-orders/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}invoices/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}quotations/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}credits/public`,
//   `${process.env.VUE_APP_COMMERCIAL_API}product-returns/public`,
//   // Ticketing
//   `${process.env.VUE_APP_TICKETS_API}ticket-externals/public`,
// ]

async function refreshTokenMethod() {
  const refreshToken = localStorageService.getRefreshToken()
  const client_id = localStorage.getItem('client_id')
  const client_secret = localStorage.getItem('client_secret')
  const response = await axios({
    method: 'post',
    url: process.env.VUE_APP_AUTHDOMAIN,
    data: qs.stringify({
      refresh_token: refreshToken,
      client_id,
      client_secret,
      grant_type: 'refresh_token',
    }),
    headers: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
  })
  if (response.status === 200) {
    localStorageService.setToken(response.data)
  }
}

axios.interceptors.request.use(
  async (config) => {
    if (
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}invoices/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}quotations/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}credits/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}purchase-orders/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}delivery-notes/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}refunds/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}credits/public`) ||
      config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}product-returns/public`) ||
      config.url.includes(`${process.env.VUE_APP_TICKETS_API}ticket-externals/public`)
    ) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('company_token')}`
      config.headers['Content-Type'] = 'application/json'
    } else if (
      config.url !== process.env.VUE_APP_AUTHDOMAIN &&
      config.url !== process.env.VUE_APP_USER_AUTHDOMAIN &&
      config.url.includes(`${process.env.VUE_APP_API}get_applications`) !== true &&
      config.url.includes(`${process.env.VUE_APP_API_V2}get_applications`) !== true &&
      config.url.includes(`${process.env.VUE_APP_API}auth/password_reset/`) !== true &&
      config.url.includes(`${process.env.VUE_APP_API}social/auth/convert-token/`) !== true &&
      !config.url.includes(`${process.env.VUE_APP_COMMERCIAL_API}send-consulted-email/`) &&
      config.url !== process.env.VUE_APP_REGISTERDOMAIN &&
      !config.url.includes('api.openweathermap') &&
      config.headers.via !== 'public'
    ) {
      const user = JSON.parse(localStorage.getItem('user'))
      config.headers.Authorization = `Bearer ${user.token}`
      config.headers['Content-Type'] = 'application/json'
    } else if (
      config.url === process.env.VUE_APP_AUTHDOMAIN ||
      config.url.includes(`${process.env.VUE_APP_API}social/auth/convert-token/`)
    ) {
      config.headers['Content-type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    }
    return config
  },
  (error) => {
    ''

    Promise.reject(error)
  },
)

// Add a response interceptor

axios.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    const originalRequest = error.config

    if (error.response && error.response.status === 401 && originalRequest.url === process.env.VUE_APP_AUTHDOMAIN) {
      router.push('/login')
      return Promise.reject(error)
    }
    const user = JSON.parse(localStorage.getItem('user'))
    // if (
    //   error.response &&
    //   error.response.status === 401 &&
    //   error.response.data === 'Jwt is expired' &&
    //   !originalRequest._retry &&
    //   user.rememberPassword
    // ) {
    //   originalRequest._retry = true
    //   const refreshToken = localStorageService.getRefreshToken()
    //   const client_id = localStorage.getItem('client_id')
    //   const client_secret = localStorage.getItem('client_secret')
    //   axios({
    //     method: 'post',
    //     url: process.env.VUE_APP_AUTHDOMAIN,
    //     data: qs.stringify({
    //       refresh_token: refreshToken,
    //       client_id,
    //       client_secret,
    //       grant_type: 'refresh_token',
    //     }),
    //     headers: {
    //       'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    //     },
    //   }).then((response) => {
    //     if (response.status === 200) {
    //       localStorageService.setToken(response.data)
    //       axios.defaults.headers.common.Authorization = `Bearer ${localStorageService.getAccessToken()}`
    //       Vue.$toast.open({
    //         message: 'Session rafraîchie !',
    //         type: 'success',
    //         position: 'top-right',
    //         duration: 6000,
    //         dismissible: true,
    //       })
    //       return axios(originalRequest)
    //     }
    //   })
    // }
    // if (
    //   error.response &&
    //   error.response.status === 401 &&
    //   error.response.data === 'Jwt is expired' &&
    //   !originalRequest._retry &&
    //   !user.rememberPassword
    // ) {
    //   router.push('/login')
    // }
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401) &&
      !error.response.config.url.includes(
        String(process.env.VUE_APP_USER_AUTHDOMAIN) &&
          !error.response.config.url.includes(String(`${process.env.VUE_APP_API_V2}get_applications`)) &&
          !error.response.config.url.includes(String(`${process.env.VUE_APP_API}users/me`)) &&
          user.token,
      )
    ) {
      if (user.rememberPassword && user.token && !originalRequest._retry && error.response.data === 'Jwt is expired') {
        originalRequest._retry = true
        await refreshTokenMethod()
        return axios(originalRequest)
      } if (user.token && (error.response.data === 'Jwt is expired' || error.response.data === 'Jwt issuer is not configured')) {
        window.location.href = '/login'
      } else {
        Vue.$toast.open({
          message: "Vous n'avez pas les droits",
          type: 'error',
          position: 'top-right',
          duration: 6000,
          dismissible: true,
        })
      }
    }
    if (
      error.response &&
      (error.response.config.method === 'post' ||
        error.response.config.method === 'put' ||
        error.response.config.method === 'patch' ||
        error.response.config.method === 'delete') &&
      !error.response.config.url.includes(String(process.env.VUE_APP_AUTHDOMAIN)) &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API}auth/password_reset/`)) &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API}totp/login/`)) &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API}get_applications`)) &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API_V2}get_applications`)) &&
      !error.response.config.url.includes(String(process.env.VUE_APP_USER_AUTHDOMAIN))
    ) {
      Vue.$toast.open({
        message: "Une erreur est survenue, certaines de vos modifications n'ont pas pu être sauvegardées",
        type: 'warning',
        position: 'top-right',
        duration: 6000,
        dismissible: true,
      })
    }
    if (
      error.response &&
      error.response.config.method === 'get' &&
      error.response.config.headers['x-toast-off'] !== 'true' &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API}get_applications`)) &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API_V2}get_applications`)) &&
      !error.response.config.url.includes(String(`${process.env.VUE_APP_API}users/me/`))
    ) {
      Vue.$toast.open({
        message: 'Une erreur est survenue, certaines de vos données ne peuvent être chargées',
        type: 'error',
        position: 'top-right',
        duration: 6000,
        dismissible: true,
      })
    }
    return Promise.reject(error)
  },
)
